var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector2X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51371 15.433C2.60954 15.4713 2.69579 15.4905 2.79163 15.4905H12.6337C13.0266 15.4905 13.3525 15.1647 13.3525 14.7718C13.3525 14.3788 13.0266 14.053 12.6337 14.053H4.52621L16.7162 1.86301C16.9941 1.5851 16.9941 1.1251 16.7162 0.84718C16.581 0.713512 16.3985 0.63855 16.2083 0.63855C16.0181 0.63855 15.8356 0.713512 15.7004 0.84718L3.51038 13.0372V4.92968C3.51038 4.53676 3.18454 4.21093 2.79163 4.21093C2.39871 4.21093 2.07288 4.53676 2.07288 4.92968V14.7718C2.07288 14.8676 2.09204 14.9538 2.13038 15.0497C2.19746 15.2222 2.34121 15.3659 2.51371 15.433ZM17.6458 18.3646H1.35413C0.961209 18.3646 0.635376 18.6904 0.635376 19.0833C0.635376 19.4762 0.961209 19.8021 1.35413 19.8021H17.6458C18.0387 19.8021 18.3645 19.4762 18.3645 19.0833C18.3645 18.6904 18.0387 18.3646 17.6458 18.3646Z",
    fill: "#6953D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2X);
export default __webpack_public_path__ + "static/media/Vector@2x.b3abf49179d87a0e185d404fd9c4948d.svg";
export { ForwardRef as ReactComponent };